import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

async function getStaffStatus(id, filter) {
	const {data} = await axios.get(`/misc/staff-status`, {params: filter});

	return data;
}

export function useStaffStatus() {
	const [filter, filterRelations] = useState({
		page: 1,
		search: null,
		limit: 10,
	});
	const [relationId, relationById] = useState(null);
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["staffStatus", relationId, filter], async () => getStaffStatus(relationId, filter));

	return {data, isLoading, isError, error, filter, filterRelations, relationById};
}
